import breakTo from '../../styles/tools/breakTo'

export default ({ colors, spacings, fontSizes, fontWeights }) => ({
  flowbar: {
    width: 'auto',
    padding: '0',

    listStyle: 'none',

    textAlign: 'center',

    // height: '8px',

    paddingTop: spacings.flowbar.paddingTop.default,
    [breakTo('medium')]: {
      paddingTop: '0'
    }
  },

  item: {
    fontWeight: fontWeights.flowbar.default,

    position: 'relative',
    display: 'inline-block',
    width: '8%',
    height: '8px',
    margin: '0',
    textAlign: 'center',
    whiteSpace: 'nowrap',

    color: 'transparent',

    [breakTo('medium')]: {
      fontSize: fontSizes.flowbar.default,

      width: '120px',
      margin: '0 1rem',
      //color: '#cecece'
      color: '#cecece' //colors.flowbar.item.default
    },

    '::before': {
      position: 'absolute',
      zIndex: '99',
      top: '0',
      left: '46%',

      display: 'block',

      width: '8px',
      height: '8px',

      content: "''",
      verticalAlign: 'middle',

      borderRadius: '8px',
      backgroundColor: colors.flowbar.bullet.default,

      [breakTo('medium')]: {
        top: '27px'
      }
    },

    '::after': {
      position: 'absolute',
      top: '3px',
      left: '50%',

      display: 'block',

      width: '100%',
      height: '2px',

      content: "''",
      verticalAlign: 'middle',

      borderRadius: '2px',
      backgroundColor: colors.flowbar.line.default,

      [breakTo('medium')]: {
        width: '155px',
        top: '30px'
      }
    },

    ':last-child': {
      '::after': {
        width: '0'
      }
    }
  },

  'item--active': {
    fontWeight: fontWeights.flowbar.default,
    /* color: colors.flowbar.line.default, */
    color: 'transparent',

    [breakTo('medium')]: {
      color: colors.flowbar.bullet.done
    },

    '::before': {
      backgroundColor: colors.flowbar.bullet.done
    },

    '::after': {
      backgroundColor: colors.flowbar.line.default
    }
  },

  'item--done': {
    fontWeight: fontWeights.flowbar.default,
    color: 'transparent',

    [breakTo('medium')]: {
      color: '#cecece'  //colors.flowbar.item.default
      //color:'#cecece'
    },

    '::before': {
      backgroundColor: colors.flowbar.bullet.done
    },

    '::after': {
      backgroundColor: colors.flowbar.line.done
    }
  }
})



// WEBPACK FOOTER //
// ./components/flowbar/styles.js